export default "__VITE_PUBLIC_ASSET__a94a5c8d__"